import { TIMEOUT_SEC, API_JWT_REFRESH_URL } from "./config.js";

//Promisify setTimeout function (of 's' seconds wait) and assign to 'timeout' variable
const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after ${s} second`));
    }, s * 1000);
  });
};

const refreshAccessToken = async function () {
  try {
    const data = await AJAX(`${API_JWT_REFRESH_URL}`, null, null, "POST");

    // ✅ update BOTH tokens (because rotation is ON)
    localStorage.setItem("accesstoken", data.access);

    return data.access;
  } catch (err) {
    console.error("Refresh failed:", err);
    throw err;
  }
};

//API for pure JSON for various url/methods/body data, including token fetch, and with timeout of 's' seconds
export const AJAX = async function (
  url,
  token = undefined,
  uploadData = undefined,
  fetchMethod,
  isRetry = false,
) {
  try {
    const fetchPro = uploadData
      ? fetch(url, {
          method: fetchMethod,
          credentials: "include",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(uploadData),
        })
      : fetch(url, {
          method: fetchMethod || "GET",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

    const res = await Promise.race([fetchPro, timeout(TIMEOUT_SEC)]);
    //will return a status and uploaded data back. Only try to parse JSON if there is content returned, e.g Delete API has no content returned.
    const data = res.status !== 204 ? await res.json() : null;
    // 🔹 Handle error responses. Below will change all error header to Error so that it can be read by err.message and it joins multiple errors together
    if (!res.ok) {
      // handle expired token
      if (
        res.status === 401 &&
        !isRetry &&
        !url.includes("/api/token/refresh/") &&
        !url.includes("/api/logout/")
      ) {
        console.warn("Token expired, attempting refresh...");

        try {
          const newAccessToken = await refreshAccessToken();

          // 🔁 retry original request and retry only once controlled by isRetry
          return await AJAX(url, newAccessToken, uploadData, fetchMethod, true);
        } catch (refreshErr) {
          console.error("Refresh failed:", refreshErr);
          throw new Error("Session expired. Please login again.");
        }
      }

      let errorMsg = "Something went wrong";

      if (data.detail) {
        errorMsg = data.detail;
      } else if (typeof data === "object" && data !== null) {
        const messages = Object.entries(data)
          .map(([field, msgs]) => {
            const niceField = field
              .replace(/_/g, " ")
              .replace(/\b\w/g, (c) => c.toUpperCase());
            const messageText = Array.isArray(msgs) ? msgs.join(", ") : msgs;

            return `${niceField}: ${messageText}`;
          })
          .join("\n"); // 👈 adds a blank line between messages
        if (messages) errorMsg = messages;
      }

      throw new Error(errorMsg);
    }
    return data;
  } catch (err) {
    throw err; //to throw the err to be handled within model.js instead of here
  }
};
